import Vue from 'vue'
import VueRouter from 'vue-router'

// 引入页面组件
import Home from '@/views/Home.vue'
import Product1Detail from '@/views/Product/Product1Detail.vue'
import Product2Detail from '@/views/Product/Product2Detail.vue'
import Product1 from '@/views/Product/Product1.vue'
import Product2 from '@/views/Product/Product2.vue'
import Solution from '@/views/Solution.vue'
import Company from '@/views/About/Company.vue'
import Base from '@/views/About/Base.vue'
import BaseDetail from '@/views/About/BaseDetail.vue'
import Contact from '@/views/About/Contact.vue'
import News from '@/views/News/Index.vue'
import NewsDetail from '@/views/News/Detail.vue'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}
const routes = [
  { path: '/', name: 'HomePage', component: Home },
  {
    path: "/product1/detail",
    name: "Product1DetailPage",
    component: Product1Detail
  },
  {
    path: "/product2/detail",
    name: "Product2DetailPage",
    component: Product2Detail
  },
  // { path: '/product/detail', name: 'ProductDetailPage', component: Product1Detail },
  { path: '/product/1', name: 'Product1Page', component: Product1 },
  { path: '/product/2', name: 'Product2Page', component: Product2 },
  { path: '/solution', name: 'SolutionPage', component: Solution },
  { path: '/news', name: 'NewsPage', component: News },
  { path: '/news/detail', name: 'NewsDetailPage', component: NewsDetail },
  { path: '/about/company', name: 'AboutCompanyPage', component: Company },
  { path: '/about/base', name: 'AboutBasePage', component: Base },
  { path: '/about/base/detail', name: 'AboutBaseDetailPage', component: BaseDetail },
  { path: '/about/contact', name: 'AboutContactPage', component: Contact },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router